import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Avatar,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import '../../styles/AirportDetailsTable.scss';
import { convertTo12HourFormat, formatDateWithAmPmBooking, formatDateWithAmPmBookingSummary } from '../../Style';

const AirportDetailsTable = ({ form1Value }) => {
  const service = form1Value?.arrival_departure_type?.value || "";

  // Prepare airport details data for table
  const prepareAirportData = () => {
    const details = [];

    if (service === "Arrival") {
      details.push(
        { field: "Travel Class", value: form1Value.type_of_class?.label || "-" },
        { field: "Airport", value: form1Value.airport?.label || "-" },
        {
          field: "Arrival Date & Time",
          value: `${form1Value.arrival_date || "-"}  ${ convertTo12HourFormat(form1Value.arrival_time) || "-"}`

        },
        { field: "Flight Number", value: form1Value.arrival_flight_number || "-" },
        { field: "PNR Number", value: form1Value.arival_pnr_by_customer || "-" },
        { field: "Airline", value: form1Value.arrival_airline || "-" },
        { field: "Arrival City", value: form1Value.arrival_city || form1Value.airport?.label || "-" }
      );
    } else if (service === "Departure") {
      details.push(
        { field: "Travel Class", value: form1Value.type_of_class?.label || "-" },
        { field: "Airport", value: form1Value.airport?.label || "-" },
        {
          field: "Departure Date & Time",
          value: `${form1Value.departure_date || "-"}  ${convertTo12HourFormat( form1Value.departure_time )|| "-"}`

        },
        { field: "Flight Number", value: form1Value.departure_flight_number || "-" },
        { field: "PNR Number", value: form1Value.departure_pnr_by_customer || "-" },
        { field: "Airline", value: form1Value.departure_airline || "-" },
        { field: "Departure City", value: form1Value.departure_city || form1Value.airport?.label || "-" }
      );
    } else {
      // Transit (both arrival and departure)
      details.push(
        { field: "Travel Class", value: form1Value.type_of_class?.label || "-" },
        { field: "Airport", value: form1Value.airport?.label || "-" },
        {
          field: "Arrival Date & Time",
           value: `${form1Value.arrival_date || "-"}  ${ convertTo12HourFormat(form1Value.arrival_time) || "-"}`,
          type: "arrival"
        },
        { field: "Arrival Flight Number", value: form1Value.arrival_flight_number || "-", type: "arrival" },
        { field: "Arrival PNR Number", value: form1Value.arival_pnr_by_customer || "-", type: "arrival" },
        { field: "Arrival Airline", value: form1Value.arrival_airline || "-", type: "arrival" },
        { field: "Arrival City", value: form1Value.arrival_city || "-", type: "arrival" },
        {
          field: "Departure Date & Time",
       value: `${form1Value.departure_date || "-"}  ${convertTo12HourFormat( form1Value.departure_time )|| "-"}`,
          type: "departure"
        },
        { field: "Departure Flight Number", value: form1Value.departure_flight_number || "-", type: "departure" },
        { field: "Departure PNR Number", value: form1Value.departure_pnr_by_customer || "-", type: "departure" },
        { field: "Departure Airline", value: form1Value.departure_airline || "-", type: "departure" },
        { field: "Departure City", value: form1Value.departure_city || "-", type: "departure" }
      );
    }

    return details;
  };

  const airportData = prepareAirportData();

  return (
    <Paper elevation={4} className="airport-details-paper">
      <Box className="airport-details-header">
        <Avatar className="airport-details-avatar">
          <LocationOnIcon className="airport-details-icon" />
        </Avatar>
        <Typography variant="h6" className="airport-details-title">
          Airport Details
        </Typography>
      </Box>

      <Divider className="airport-details-divider" />

      {airportData.length > 0 ? (
        <TableContainer className="airport-table-container">
          <Table className="airport-table" aria-label="airport details table">
            <TableHead>
              <TableRow className="airport-table-header">
                <TableCell className="airport-table-cell-header">Field</TableCell>
                <TableCell className="airport-table-cell-header">Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {airportData.map((detail, index) => (
                <TableRow
                  key={index}
                  className={`airport-table-row ${index % 2 === 0 ? 'airport-table-row-even' : 'airport-table-row-odd'} ${detail.type ? `airport-row-${detail.type}` : ''}`}
                >
                  <TableCell className="airport-table-cell airport-field-cell">
                    <span className={`airport-field-label ${detail.type ? `field-${detail.type}` : ''}`}>
                      {detail.field}
                    </span>
                  </TableCell>
                  <TableCell className="airport-table-cell airport-value-cell">
                    {detail.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box className="no-airport-data">
          <Typography variant="body1" className="no-data-text">
            No airport details available.
          </Typography>
        </Box>
      )}

      {/* Service Type Badge */}
      <Box className="service-type-badge-container">
        <span className={`service-type-badge service-${service.toLowerCase()}`}>
          {service} Service
        </span>
      </Box>
    </Paper>
  );
};

export default AirportDetailsTable;